import React, { useEffect, useState } from "react";

import '../css/Dashboard.css'
import { useDispatch, useSelector } from "react-redux";
import { setUserId, setUserName, setUserEmail } from "../../Redux/reducers/UserSlice";
import { Link, Outlet } from "react-router-dom";
import OrdersManagement from "./OrdersManagement";
import UsersManagement from "./UsersManagement";
import ProductsManagement from "./ProductsManagement";
import axios from "axios";


const Dashboard = ({ isAuthenticatedAd, activeManagement, setActiveManagement }) => {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.user.userId)
    const userName = useSelector(state => state.user.userName)
    const { apiUrl } = useSelector(state => state.api);

    useEffect(() => {
        //find info user
        const findInfo = async () => {
            try {
                const response = await axios.get(`${apiUrl}/dashboard`, {
                    headers: { token: localStorage.token },
                })
                const parseRes = await response.data;
                dispatch(setUserName(parseRes.user_name))
                dispatch(setUserEmail(parseRes.user_email))
                dispatch(setUserId(parseRes.user_id))
            } catch (err) {
                console.error(err.message);
            }
        }
        findInfo();
    }, [apiUrl, dispatch]);

    const changeSelection = (e) => {
        setActiveManagement(e.target.innerText);
    }
    return (
        <>

            {(isAuthenticatedAd && isAuthenticatedAd !== "user") ? (
                <div className="container-myaccount justify-content-center align-items-center" >
                    <h1 className="text-center"> Welcome to Dashboard</h1>
                    <h5 className="text-center">Manage Products, Users, Orders for your Store</h5>

                    {/* 
                    <div className="col-md-7">
                        <div className="card bg-light mb-3 m-2">
                            <div className="card-body d-flex justify-content-between align-items-center">
                                <div className="card-text text-center">Your ID: {userId} </div>
                            </div>

                        </div>
                    </div> */}

                    <div className="row">
                        <div className="col-md-2 text-left">
                            <div className="item-list">
                                <h3 >Management</h3>
                                <div className="bg-light">
                                    <Link to="/dashboard/ordersmanagement" className="text-decoration-none text-reset">
                                        <div className={activeManagement === 'Orders' ? 'item active' : 'item'}
                                            onClick={(e) => { changeSelection(e) }}
                                        >Orders</div>
                                    </Link>
                                </div>
                                <div className="bg-light ">

                                    <Link to="/dashboard/productsmanagement" className="text-decoration-none text-reset">
                                        <div className={activeManagement === 'Products' ? 'item active' : 'item'} onClick={changeSelection}>Products</div>
                                    </Link>
                                </div>
                                <div className="bg-light">

                                    <Link to="/dashboard/usersmanagement" className="text-decoration-none text-reset">
                                        <div className={activeManagement === 'Users' ? 'item active' : 'item'} onClick={changeSelection}>Users</div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* Profile */}
                        {/* Change password */}
                        {/* Orders*/}
                        <Outlet />
                        {/* {(activeManagement === 'Orders') ? (<OrdersManagement />) : (activeManagement === 'Products') ? (<ProductsManagement />) : (<UsersManagement />)} */}
                    </div>
                </div >
            ) : (
                <div className="container-not">
                    <div className="d-flex justify-content-center align-items-center">
                        <img src="/frusti.jpg"
                            alt="Not-Authorized"
                            class="notAuthor" ></img>
                    </div>
                </div>
            )}

        </>

    )

}

export default Dashboard;